"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateLoginTokenRequest = void 0;
var ValidateLoginTokenRequest = /** @class */ (function () {
    function ValidateLoginTokenRequest(token) {
        this.token = token;
    }
    return ValidateLoginTokenRequest;
}());
exports.ValidateLoginTokenRequest = ValidateLoginTokenRequest;
//# sourceMappingURL=ValidateLoginTokenRequest.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/models/request/ValidateLoginTokenRequest.js
// module id = 1501
// module chunks = 8